import React from "react";
import { CgSpinnerAlt } from "react-icons/cg";
import { BsFillSendFill } from "react-icons/bs";

const ChatBox = ({ isBotTyping, onChange, inputMessage, inputHeight, handleKeyDown, formRef, onSubmit, categoryID, textareaRef }) => {
    return (isBotTyping) ? (
        <form ref={formRef}>
            <textarea className='chat-box-field' name="inputMessage" id="inputMessage" cols="30" rows="1" placeholder='ARI is typing...' onChange={onChange} value={inputMessage} style={{ height: 'auto' }} disabled={true}></textarea>
            <input type="hidden" name="categoryID" value={categoryID} />
            <button className='spinner loader-spinner' type="button">
                <CgSpinnerAlt />
            </button>
        </form>
    ) : (<>
        <form ref={formRef} onSubmit={onSubmit}>
            <textarea className='chat-box-field' name="inputMessage" id="inputMessage" cols="30" rows="1" placeholder='Ask Anything...' onChange={onChange} value={inputMessage} style={{ height: inputHeight }} onKeyDown={handleKeyDown} ref={textareaRef}></textarea>
            <input type="hidden" name="categoryID" value={categoryID} />
            <button type="submit">
                <BsFillSendFill />
            </button>
        </form>
    </>);
}

export default ChatBox;